<template>
	<type-wrapper class="type-M" limit>
		<type-grid row="1" class="type-M-header">
			<div class="label-item" :key="index" @click="curIndex = index" v-for="(item, index) in showData" :class="index === curIndex ? 'label-item-active' : ''">{{ item.name }}</div>
		</type-grid>
		<type-grid row="1" margin class="type-M-content">
			<div class="content-container" :style="style">
				<div class="content-item" :key="index" :style="_style" v-for="(item, index) in showData">
					<type-grid row="2" margin>
						<type-image mode="widthFix" :src="item.photo"></type-image>
					</type-grid>
					<type-grid row="2" margin>
						<type-title medium v-if="item.title">{{ item.title }}</type-title>
						<type-content large v-if="item.content" :style="contentColor">{{ item.content }}</type-content>
					</type-grid>
				</div>
			</div>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// N分图文书签
	import mixin from '../mixin.js'
	export default {
		name: 'type-M',
		mixins: [ mixin ],
		data() {
			return {
				curIndex: 0
			}
		},
		computed: {
			style() {
				let marginLeft = `-${this.curIndex * 100}%`;
				return `width: ${this.showData.length * 100}%;margin-left: ${marginLeft};`;
			},
			_style() {
				return `width: calc(100% / ${this.showData.length});`;
			}
		}
	}
</script>

<style scoped lang="less">
	.type-M{
		.type-M-header{
			display: flex;
			justify-content: center;
			.label-item{
				cursor: pointer;
				font-size: 16px;
				font-weight: 300;
				display: inline-flex;
				padding: 0 15px 15px;
				&-active{
					border-bottom: 1px solid #41466E;
				}
			}
		}
		.type-M-content{
			overflow: hidden;
			.content-container{
				transition: margin-left 300ms linear;
				.content-item{
					display: inline-flex;
					flex-wrap: wrap;
					vertical-align: top;
				}
			}
		}
	}
</style>
